export const environment = {
  BASE_URL: 'https://oblation.satsangnepal.org.np',
  SSO_URL: 'https://sso.satsang.global',
  localhostUrl: '',
  orgUrl: 'https://satsangnepal.org.np/',
  returnUrl: 'https://oblation.satsangnepal.org.np/pre-login',
  photoSocketUrl: 'wss://oblation.satsangnepal.org.np/socket',
  activityLogoutTimeInMins: 60,
  production: true,
  IST_FORM: ['APRNM', 'DPRNM', 'PRVRT'],
  MISC_CODE_TYPE: ['MANDIR', 'MISC'],
  PHIL_NAME: 'Satsang Philanthropy Nepal',
  STATE_LABEL: 'Province',
  DISTRICT_LABEL: 'District',
  LOCAL_ADMIN_DIV: 'Municipality',
  CONTACT_NO_REGEX: /^(97|98)\d{8}$/,
  BASE_COUNTRY: 'Nepal',
  ISD_CODE: '+977',
  CONTACT_NO_LENGTH: 10,
};
